module.exports = __webpack_public_path__ + "images/illustrations/reach-icon-globe-601a818c63990367a3d6bfc7157aed71.svg";